var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useCallback, useContext, useEffect } from 'react';
import { safeHidePopover, safeShowPopover } from '#services';
import { ToastServiceContext } from './ToastServiceContext';
export const useToastService = () => {
    _react_refresh_temp_1();
    const toastServiceValue = useContext(ToastServiceContext);
    if (!toastServiceValue) {
        throw new Error('ToastService context not available!');
    }
    const { setToastContainer, setToasts, toastContainer, toasts } = toastServiceValue;
    const bringToastsToTop = useCallback(() => {
        // First hide (remove popover from top-layer), then show it again so that
        // it appears last in the top-layer. The safe* helpers guard the disconnect
        // race (LUCID-28743 / LUCID-29872) and the missing Popover API (LUCID-29873).
        safeHidePopover(toastContainer);
        safeShowPopover(toastContainer);
    }, [toastContainer]);
    const addToast = useCallback((toast) => {
        const newToast = { id: toast.id ?? crypto.randomUUID(), ...toast };
        setToasts((prev) => [...prev, newToast]);
    }, [setToasts]);
    const removeToast = useCallback((id) => {
        setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, [setToasts]);
    useEffect(() => {
        safeShowPopover(toastContainer);
    }, [toastContainer]);
    return {
        toasts,
        addToast,
        removeToast,
        setToastContainer,
        bringToastsToTop,
    };
};
_react_refresh_temp_1(useToastService, "5VPsu/0lJCrvKDUjnJUTpYbzhdY=");
